import { Alert, Box, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { DisplayImage } from "@/components/common/DisplayImage";
import PdfPreview from "@/components/common/pdfPreview";

type Props = {
  url?: string | null;
  title: string;
  isImage: boolean;
  isPDF: boolean;
  onOpen?: () => void;
};

/** Compact thumbnail; the row's Open action shows the full document. */
export function DocumentPreview({ url, title, isImage, isPDF, onOpen }: Props) {
  const [failed, setFailed] = useState(false);
  const previewUrl = url?.trim();
  useEffect(() => setFailed(false), [previewUrl]);

  if (!previewUrl) {
    return (
      <Box sx={{ display: "grid", placeItems: "center", height: "100%", minHeight: 160, p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {t("document.review.unavailable")}
        </Typography>
      </Box>
    );
  }
  if (failed) {
    return <Alert severity="error">{t("document.review.previewError")}</Alert>;
  }
  return (
    <Box sx={{ position: "relative" }}>
      {isPDF ? (
        <PdfPreview url={previewUrl} onLoadError={() => setFailed(true)} />
      ) : isImage ? (
        <DisplayImage
          image={{ url: previewUrl }}
          alt={title}
          onClick={onOpen}
          sx={{
            display: "block",
            maxWidth: "100%",
            maxHeight: 160,
            mx: "auto",
            objectFit: "contain",
            cursor: onOpen ? "zoom-in" : undefined,
          }}
        />
      ) : (
        <Alert severity="warning">{t("document.review.unsupported")}</Alert>
      )}
    </Box>
  );
}
